export default "__VITE_ASSET__Byn_GQr$__"